import * as Types from '../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInternetCostMutationVariables = Types.Exact<{
  yyyymm: Types.Scalars['String']['input'];
  file: Types.Scalars['Upload']['input'];
}>;


export type UpdateInternetCostMutation = { __typename?: 'Mutation', updateInternetCost: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateInternetCostDocument = gql`
    mutation UpdateInternetCost($yyyymm: String!, $file: Upload!) {
  updateInternetCost(yyyymm: $yyyymm, file: $file) {
    count
    error
  }
}
    `;
export type UpdateInternetCostMutationFn = Apollo.MutationFunction<UpdateInternetCostMutation, UpdateInternetCostMutationVariables>;

/**
 * __useUpdateInternetCostMutation__
 *
 * To run a mutation, you first call `useUpdateInternetCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternetCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternetCostMutation, { data, loading, error }] = useUpdateInternetCostMutation({
 *   variables: {
 *      yyyymm: // value for 'yyyymm'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateInternetCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternetCostMutation, UpdateInternetCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternetCostMutation, UpdateInternetCostMutationVariables>(UpdateInternetCostDocument, options);
      }
export type UpdateInternetCostMutationHookResult = ReturnType<typeof useUpdateInternetCostMutation>;
export type UpdateInternetCostMutationResult = Apollo.MutationResult<UpdateInternetCostMutation>;
export type UpdateInternetCostMutationOptions = Apollo.BaseMutationOptions<UpdateInternetCostMutation, UpdateInternetCostMutationVariables>;